import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home.vue'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/v2/home.vue')
  },
  {
    path: '/hexinchanpin',
    name: 'hexinchanpin',
    meta: {
      title: '核心产品'
    },
    component: () => import('../views/v2/product.vue')
  },
  {
    path: '/shujuchanpin',
    name: 'shujuchanpin',
    meta: {
      title: '数据产品'
    },
    component: () => import('../views/v2/dataProduct.vue')
  },
  {
    path: '/car',
    name: 'car',
    meta: {
      title: '罗盘车辆大数据'
    },
    component: () => import('../views/v2/car.vue')
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: '关于我们'
    },
    component: () => import('../views/v2/about.vue')
  },
  {
    path: '/chanpin/hujiaozhongxin',
    name: '/chanpin/hujiaozhongxin',
    meta: {
      title: '呼叫中心解决方案'
    },
    component: () => import('../views/AIOutboundCall/unauthPage/index.vue')
  },
  {
    path: '/chanpin/duanxinyingxiao',
    name: '/chanpin/duanxinyingxiao',
    meta: {
      title: '短信解决方案'
    },
    component: () => import('../views/accurateTouch/textMessage/unauthPage/index.vue')
  },
  {
    path: '/chanpin/guanggaozhushou',
    name: '/chanpin/guanggaozhushou',
    meta: {
      title: '广告助手解决方案'
    },
    component: () => import('../views/marketing/unauthPage/index.vue')
  },
  // {
  //   path: '/shutong',
  //   name: 'shutong',
  //   meta: {
  //     title: '极光数通'
  //   },
  //   component: () => import('../views/index/marketing.vue')
  // },
  {
    path: '/tianqi',
    name: 'tianqi',
    meta: {
      title: '极光天启'
    },
    component: () => import('../views/index/data.vue')
  },
  {
    path: '/zhaoshangqudao',
    name: 'zhaoshangqudao',
    meta: {
      title: '招商渠道'
    },
    component: () => import('../views/index/channel.vue')
  },
  {
    path: '/jiage',
    name: 'jiage',
    meta: {
      title: '价格'
    },
    component: () => import('../views/index/price.vue')
  },
  // {
  //   path: '/guanyuwomen',
  //   name: 'guanyuwomen',
  //   meta: {
  //     title: '关于我们'
  //   },
  //   component: () => import('../views/index/about.vue')
  // },
  {
    path: '/dataMallDetail',
    name: 'dataMallDetail',
    meta: {
      title: '数据详情'
    },
    component: () => import('../views/dataMall/dataDetail.vue')
  },
  {
    path: '/datallApiquanbu',
    name: 'datallApiquanbu',
    meta: {
      title: '数据api商城全部'
    },
    component: () => import('../views/dataMall/dataDetallApi.vue')
  },
  {
    path: '/datalljibenxinxi',
    name: 'datalljibenxinxi',
    meta: {
      title: '数据api商城详情'
    },
    component: () => import('../views/dataMall/dataDetalljibenxinxi.vue')
  },
  {
    path: '/apiMall',
    name: 'apiMall',
    meta: {
      title: '数据api商城详情'
    },
    // component: () => import('../views/dataMall/dataDetalljibenxinxi2.vue')
    component: () => import('../views/dataMall/apiMall.vue')
  },
  {
    path: '/apiList',
    name: 'apiList',
    meta: {
      title: '数据api商城详情'
    },
    component: () => import('../views/dataMall/dataDetalljibenxinxi2.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      title: '用户协议'
    },
    component: () => import('../views/homePage/agreement.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: {
      title: '隐私策略'
    },
    component: () => import('../views/homePage/privacy.vue')
  },
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // {
  //   path: '/',
  //   name: 'home',
  //   component: home
  // },
  // {
  //   path: '/',
  //   name: 'home',
  //   meta: {
  //     title: '极光天启'
  //   },
  //   component: () => import('../views/index/data.vue')
  // },
  {
    path: '/index',
    name: 'index',
    // component: () => import('../views/index.vue')
    component: () => import('../views/dataMall/index.vue')
    // component: () => import('../views/massiveCustomer/advancedSearch.vue')
  },
  ////////////////////////////////////////////////////////////////////////////////////////
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '积分充值',
      hideLayout: true
    },
    component: () => import('../components/register.vue')
  }
  , {
    path: '/personalCenter',
    name: 'personalCenter',
    meta: {
      title: '个人中心'
    },
    component: () => import('../views/user/personalCenter.vue')
  }
  , {
    path: '/message',
    name: 'message',
    meta: {
      title: '消息中心'
    },
    component: () => import('../views/message/message.vue')
  }
  , {
    path: '/ocpc/advancedSearch',
    name: 'advancedSearch',
    meta: {
      title: '高级搜索'
    },
    component: () => import('../views/massiveCustomer/advancedSearch.vue')
  }
  , {
    path: '/ocpc/dataDownload',
    name: '/ocpc/dataDownload',
    meta: {
      title: '模型获客'
    },
    component: () => import('../views/massiveCustomer/dataDownload.vue')
  }
  , {
    path: '/ocpc/dataUpload',
    name: '/ocpc/dataUpload',
    meta: {
      title: '数据上传'
    },
    component: () => import('../views/massiveCustomer/dataUpload.vue')
  }
  , {
    path: '/ocpc/busPhoneUpload',
    name: '/ocpc/busPhoneUpload',
    meta: {
      title: '工商联系人'
    },
    component: () => import('../views/massiveCustomer/busPhoneUpload.vue')
  }
  , {
    path: '/ocpc/taxBill',
    name: '/ocpc/taxBill',
    meta: {
      title: '税票查询'
    },
    component: () => import('../views/massiveCustomer/taxBill.vue')
  }
  , {
    path: '/ocpc/apiBill',
    name: '/ocpc/apiBill',
    meta: {
      title: '接口账单'
    },
    component: () => import('../views/massiveCustomer/apiBill.vue')
  }

  , {
    path: '/ocpc/guessYouLike',
    name: '/ocpc/guessYouLike',
    meta: {
      title: '潜客推荐'
    },
    component: () => import('../views/massiveCustomer/guessYouLike.vue')
  }
  , {
    path: '/ocpc/similarRecommend',
    name: '/ocpc/similarRecommend',
    meta: {
      title: '模型拓客'
    },
    component: () => import('../views/massiveCustomer/similarRecommend.vue')
  }
  , {
    path: '/ocpc/map',
    name: '/ocpc/map',
    meta: {
      title: '地图拓客'
    },
    component: () => import('../views/massiveCustomer/map.vue')
  }
  , {
    path: '/ocpc/batchQuery',
    name: '/ocpc/batchQuery',
    meta: {
      title: '批量补全'
    },
    component: () => import('../views/massiveCustomer/batchQuery.vue')
  }
  , {
    path: '/marketing/taskList',
    name: '/marketing/taskList',
    meta: {
      title: '任务列表'
    },
    component: () => import('../views/accurateTouch/taskList.vue')
  }
  , {
    path: '/marketing/massMailing',
    name: '/marketing/massMailing',
    meta: {
      title: '邮箱群发'
    },
    component: () => import('../views/accurateTouch/email/massMailing.vue')
  }
  , {
    path: '/newMassMailing',
    name: 'newMassMailing',
    meta: {
      title: '新建邮箱群发'
    },
    component: () => import('../views/accurateTouch/email/newMassMailing.vue')
  }
  , {
    path: '/mailTemplate',
    name: 'mailTemplate',
    meta: {
      title: '邮件模板'
    },
    component: () => import('../views/accurateTouch/email/mailTemplate.vue')
  }
  , {
    path: '/mailTemplatePreview',
    name: 'mailTemplatePreview',
    meta: {
      title: '邮件模板预览'
    },
    component: () => import('../views/accurateTouch/email/mailTemplatePreview.vue')
  }
  , {
    path: '/specification',
    name: 'specification',
    meta: {
      title: '邮件内容规范'
    },
    component: () => import('../views/accurateTouch/email/specification.vue')
  }
  , {
    path: '/marketing/SMS',
    name: '/marketing/SMS',
    meta: {
      title: '短信群发'
    },
    component: () => import('../views/accurateTouch/textMessage/SMS.vue')
  }, {
    path: '/marketing/SMS2',
    name: '/marketing/SMS2',
    meta: {
      title: '短信群发'
    },
    component: () => import('../views/accurateTouch/textMessage/SMS2.vue')
  }
  , {
    path: '/ImportSMSGroupSending',
    name: 'ImportSMSGroupSending',
    meta: {
      title: '导入手机号群发'
    },
    component: () => import('../views/accurateTouch/textMessage/ImportSMSGroupSending.vue')
  }
  , {
    path: '/SMSGroupSending',
    name: 'SMSGroupSending',
    meta: {
      title: '新建短信群发'
    },
    component: () => import('../views/accurateTouch/textMessage/SMSGroupSending.vue')
  }
  , {
    path: '/SMSSendView',
    name: 'SMSSendView',
    meta: {
      title: '查看短信群发'
    },
    component: () => import('../views/accurateTouch/textMessage/SMSSendView.vue')
  }
  , {
    path: '/SMSTemplate',
    name: 'SMSTemplate',
    meta: {
      title: '新建短信模板'
    },
    component: () => import('../views/accurateTouch/textMessage/SMSTemplate.vue')
  }
  , {
    path: '/SMSSignature',
    name: 'SMSSignature',
    meta: {
      title: '新建短信签名'
    },
    component: () => import('../views/accurateTouch/textMessage/SMSSignature.vue')
  }
  , {
    path: '/SMSSignatureNew',
    name: 'SMSSignatureNew',
    meta: {
      title: '新建短信签名'
    },
    component: () => import('../views/accurateTouch/textMessage/SMSSignatureNew.vue')
  }
  , {
    path: '/SMSContentSpecification',
    name: 'SMSContentSpecification',
    meta: {
      title: '短信内容规范'
    },
    component: () => import('../views/accurateTouch/textMessage/SMSContentSpecification.vue')
  }
  , {
    path: '/resource/crowdPack',
    name: '/resource/crowdPack',
    meta: {
      title: '人群包'
    },
    component: () => import('../views/customerResources/crowdPack.vue')
  }
  , {
    path: '/crowdPackList',
    name: 'crowdPackList',
    meta: {
      title: '默认人群包'
    },
    component: () => import('../views/customerResources/crowdPackList.vue')
  }
  , {
    path: '/resource/customerPool',
    name: '/resource/customerPool',
    meta: {
      title: '客户池'
    },
    component: () => import('../views/customerResources/customerPool.vue')
  }
  , {
    path: '/upToDate',
    name: 'upToDate',
    meta: {
      title: '最新的企业'
    },
    component: () => import('../views/upToDate/upToDate.vue')
  }
  , {
    path: '/moreInformation',
    name: 'moreInformation',
    meta: {
      title: '更多资讯'
    },
    component: () => import('../views/information/moreInformation.vue')
  }
  , {
    path: '/dataMall',
    name: 'dataMall',
    meta: {
      title: '数据商城'
    },
    component: () => import('../views/information/dataMall.vue')
  }
  , {
    path: '/newsday',
    name: 'newsday',
    meta: {
      title: '新闻日报'
    },
    component: () => import('../views/information/newsday.vue')
  }
  , {
    path: '/newsdayInfo',
    name: 'newsdayInfo',
    meta: {
      title: '新闻日报详情'
    },
    component: () => import('../views/information/newsdayInfo.vue')
  }
  , {
    path: '/companyInfo',
    name: 'companyInfo',
    meta: {
      title: '公司信息'
    },
    component: () => import('../views/company/companyInfo.vue')
  }
  , {
    path: '/companyOverview',
    name: 'companyOverview',
    meta: {
      title: '公司概览'
    },
    component: () => import('../views/company/basicInfo/companyOverview.vue')
  }
  , {
    path: '/businessInfo',
    name: 'businessInfo',
    meta: {
      title: '工商信息'
    },
    component: () => import('../views/company/basicInfo/businessInfo.vue')
  }
  , {
    path: '/shareholderInfo',
    name: 'shareholderInfo',
    meta: {
      title: '股东信息'
    },
    component: () => import('../views/company/basicInfo/shareholderInfo.vue')
  }
  , {
    path: '/organizationStructure',
    name: 'organizationStructure',
    meta: {
      title: '组织结构'
    },
    component: () => import('../views/company/basicInfo/organizationStructure.vue')
  }
  , {
    path: '/changeRecord',
    name: 'changeRecord',
    meta: {
      title: '变更记录'
    },
    component: () => import('../views/company/basicInfo/changeRecord.vue')
  }
  , {
    path: '/telecomLicense',
    name: 'telecomLicense',
    meta: {
      title: '电信许可'
    },
    component: () => import('../views/company/basicInfo/telecomLicense.vue')
  }
  , {
    path: '/importExportCredit',
    name: 'importExportCredit',
    meta: {
      title: '进出口信用'
    },
    component: () => import('../views/company/basicInfo/importExportCredit.vue')
  }
  , {
    path: '/relationshipGraph',
    name: 'relationshipGraph',
    meta: {
      title: '关系图谱'
    },
    component: () => import('../views/company/basicInfo/relationshipGraph.vue')
  }
  , {
    path: '/members',
    name: 'members',
    meta: {
      title: '所有成员'
    },
    component: () => import('../views/company/contacts/members.vue')
  }
  , {
    path: '/leadingMember',
    name: 'leadingMember',
    meta: {
      title: '主要成员'
    },
    component: () => import('../views/company/contacts/leadingMember.vue')
  }
  , {
    path: '/recruitmentInformation',
    name: 'recruitmentInformation',
    meta: {
      title: '招聘信息'
    },
    component: () => import('../views/company/businessSituation/recruitmentInformation.vue')
  }
  , {
    path: '/tenderingAndBidding',
    name: 'tenderingAndBidding',
    meta: {
      title: '招投标'
    },
    component: () => import('../views/company/businessSituation/tenderingAndBidding.vue')
  }
  , {
    path: '/upstreamAndDownstream',
    name: 'upstreamAndDownstream',
    meta: {
      title: '上下游'
    },
    component: () => import('../views/company/businessSituation/upstreamAndDownstream.vue')
  }
  , {
    path: '/newsAndPublicOpinion',
    name: 'newsAndPublicOpinion',
    meta: {
      title: '新闻舆情'
    },
    component: () => import('../views/company/businessSituation/newsAndPublicOpinion.vue')
  }
  , {
    path: '/businessOpportunityMonitoring',
    name: 'businessOpportunityMonitoring',
    meta: {
      title: '商机监控'
    },
    component: () => import('../views/company/businessSituation/businessOpportunityMonitoring.vue')
  }
  , {
    path: '/financingProcess',
    name: 'financingProcess',
    meta: {
      title: '融资历程'
    },
    component: () => import('../views/company/businessSituation/financingProcess.vue')
  }
  , {
    path: '/legalProceedings',
    name: 'legalProceedings',
    meta: {
      title: '法律诉讼'
    },
    component: () => import('../views/company/judicialRisk/legalProceedings.vue')
  }
  , {
    path: '/announcementOfCourtSession',
    name: 'announcementOfCourtSession',
    meta: {
      title: '开庭公告'
    },
    component: () => import('../views/company/judicialRisk/announcementOfCourtSession.vue')
  }
  , {
    path: '/qualificationCertificate',
    name: 'qualificationCertificate',
    meta: {
      title: '资质证书'
    },
    component: () => import('../views/company/intellectualPropertyRights/qualificationCertificate.vue')
  }
  , {
    path: '/patentInfo',
    name: 'patentInfo',
    meta: {
      title: '专利信息'
    },
    component: () => import('../views/company/intellectualPropertyRights/patentInfo.vue')
  }
  , {
    path: '/trademarkInfo',
    name: 'trademarkInfo',
    meta: {
      title: '商标信息'
    },
    component: () => import('../views/company/intellectualPropertyRights/trademarkInfo.vue')
  }
  , {
    path: '/shop',
    name: 'shop',
    meta: {
      title: '网店'
    },
    component: () => import('../views/company/promotionInfo/shop.vue')
  }
  , {
    path: '/ICP',
    name: 'ICP',
    meta: {
      title: '网站备案'
    },
    component: () => import('../views/company/promotionInfo/ICP.vue')
  }
  , {
    path: '/applicationInfo',
    name: 'applicationInfo',
    meta: {
      title: '应用信息'
    },
    component: () => import('../views/company/promotionInfo/applicationInfo.vue')
  }
  , {
    path: '/keyPersonnel',
    name: 'keyPersonnel',
    meta: {
      title: '主要人员'
    },
    component: () => import('../views/company/other/keyPersonnel.vue')
  }
  , {
    path: '/taxGrade',
    name: 'taxGrade',
    meta: {
      title: '税务评级'
    },
    component: () => import('../views/company/other/taxGrade.vue')
  }
  // ,{
  //   path: '/officialAccountChangeRecord',
  //   name: 'officialAccountChangeRecord',
  //   meta: {
  //     title: '公众号变更记录'
  //   },
  //   component: () => import('../views/company/other/officialAccountChangeRecord.vue')
  // }
  , {
    path: '/enterpriseBusiness',
    name: 'enterpriseBusiness',
    meta: {
      title: '企业业务'
    },
    component: () => import('../views/company/other/enterpriseBusiness.vue')
  }
  , {
    path: '/competitiveInfo',
    name: 'competitiveInfo',
    meta: {
      title: '竞品信息'
    },
    component: () => import('../views/company/other/competitiveInfo.vue')
  }
  , {
    path: '/copyrightOfWorks',
    name: 'copyrightOfWorks',
    meta: {
      title: '作品著作权'
    },
    component: () => import('../views/company/intellectualPropertyRights/copyrightOfWorks.vue')
  }
  , {
    path: '/softwareCopyrights',
    name: 'softwareCopyrights',
    meta: {
      title: '软件著作权'
    },
    component: () => import('../views/company/intellectualPropertyRights/softwareCopyrights.vue')
  },

  /** AIGC云 */
  , {
    path: '/aigc/textGeneration',
    name: '/aigc/textGeneration',
    meta: {
      title: '文本生成'
    },
    component: () => import('../views/aigc/textGeneration.vue')
  },
  , {
    path: '/aigc/imageGeneration',
    name: '/aigc/imageGeneration',
    meta: {
      title: '图片生成'
    },
    component: () => import('../views/aigc/imageGeneration.vue')
  },

  , {
    path: '/aigc/videoGeneration',
    name: '/aigc/videoGeneration',
    meta: {
      title: '视频生成'
    },
    component: () => import('../views/aigc/videoGeneration.vue')
  },

  , {
    path: '/aigc/textRecognize',
    name: '/aigc/textRecognize',
    meta: {
      title: '文字识别'
    },
    component: () => import('../views/aigc/textRecognize.vue')
  },
  , {
    path: '/aigc/imageTextConversion',
    name: '/aigc/imageTextConversion',
    meta: {
      title: '图文互转'
    },
    component: () => import('../views/aigc/imageTextConversion.vue')
  },
  , {
    path: '/aigc/audioProcessing',
    name: '/aigc/audioProcessing',
    meta: {
      title: '音频处理'
    },
    component: () => import('../views/aigc/audioProcessing.vue')
  },

  /** 数字化营销 */

  // 营销推广
  {
    path: '/marketing/marketing',
    name: '/marketing/marketing',
    meta: {
      title: '营销推广'
    },
    component: () => import('../views/marketing/marketing.vue')
  },

  /** OSINT云 */
  {
    path: '/osint/customerProfile',
    name: '/osint/customerProfile',
    meta: {
      title: '客户档案'
    },
    component: () => import('../views/osint/customerProfile.vue')
  },
  {
    path: '/osint/enterpriseMap',
    name: '/osint/enterpriseMap',
    meta: {
      title: '企业图谱'
    },
    component: () => import('../views/osint/enterpriseMap.vue')
  },
  {
    path: '/osint/KPdataCustomized',
    name: '/osint/KPdataCustomized',
    meta: {
      title: 'KP数据定制'
    },
    component: () => import('../views/osint/KPdataCustomized.vue')
  },
  {
    path: '/osint/corporateInformation',
    name: '/osint/corporateInformation',
    meta: {
      title: '企业资讯'
    },
    component: () => import('../views/osint/corporateInformation.vue')
  },
  {
    path: '/advft',
    name: 'advft',
    meta: {
      title: '招投标高级搜索'
    },
    component: () => import('../views/osint/components/bidding/advancedSearchForTenders.vue')
  },

  /** AI外呼 */
  // {
  //   path: '/marketing/AIOutboundCall',
  //   name: '/marketing/AIOutboundCall',
  //   meta: {
  //     title: '企业资讯'
  //   },
  //   component: () => import('../views/AIOutboundCall/AIOutboundCall.vue')
  // },
  // 录音质检
  {
    path: '/marketing/AIOutboundCall/RecordingInspection',
    name: '/marketing/AIOutboundCall/RecordingInspection',
    meta: {
      title: '录音质检'
    },
    component: () => import('../views/AIOutboundCall/RecordingInspection.vue')
  },
  // 客户话单
  {
    path: '/marketing/AIOutboundCall/CustomerCallList',
    name: '/marketing/AIOutboundCall/CustomerCallList',
    meta: {
      title: '客户话单'
    },
    component: () => import('../views/AIOutboundCall/CustomerCallList.vue')
  },
  // 坐席报表
  {
    path: '/marketing/AIOutboundCall/AgentReport',
    name: '/marketing/AIOutboundCall/AgentReport',
    meta: {
      title: '坐席报表'
    },
    component: () => import('../views/AIOutboundCall/AgentReport.vue')
  },

  /** crm */
  {
    path: '/crm',
    name: '/crm',
    meta: {
      title: '企业资讯'
    },
    component: () => import('../views/crm/index.vue')
  },

  /** CRM */
  {
    path: '/crm/fieldSet/fieldSetList',
    name: '/crm/fieldSet/fieldSetList',
    meta: {
      title: '字段设置'
    },
    component: () => import('../views/crm/fieldSet/fieldSetList.vue')
  },
  {
    path: '/crm/fieldSet/fieldSetInfo',
    name: '/crm/fieldSet/fieldSetInfo',
    meta: {
      title: '字段详情'
    },
    component: () => import('../views/crm/fieldSet/fieldSetInfo.vue')
  },
  {
    path: '/crm/highSeasPool/highSeasPool',
    name: '/crm/highSeasPool/highSeasPool',
    meta: {
      title: '公海池'
    },
    component: () => import('../views/crm/highSeasPool/highSeasPool.vue')
  },
  {
    path: '/crm/businessManage/businessManage',
    name: '/crm/businessManage/businessManage',
    meta: {
      title: '商机管理'
    },
    component: () => import('../views/crm/businessManage/businessManage.vue')
  },
  // {
  //   path: '/crm/businessManage/businessMaintenance',
  //   name: '/crm/businessManage/businessMaintenance',
  //   meta: {
  //     title: '商机维护'
  //   },
  //   component: () => import('../views/crm/businessManage/businessMaintenance.vue')
  // },
  {
    path: '/crm/contractManage/contractManage',
    name: '/crm/contractManage/contractManage',
    meta: {
      title: '合同管理'
    },
    component: () => import('../views/crm/contractManage/contractManage.vue')
  },
  {
    path: '/crm/clue/unallocatedClue',
    name: '/crm/clue/unallocatedClue',
    meta: {
      title: '待分配线索'
    },
    component: () => import('../views/crm/clue/unallocatedClue.vue')
  },
  {
    path: '/crm/clue/clueManage',
    name: '/crm/clue/clueManage',
    meta: {
      title: '线索管理'
    },
    component: () => import('../views/crm/clue/clueManage.vue')
  },
  {
    path: '/crm/custGroup/custGroup',
    name: '/crm/custGroup/custGroup',
    meta: {
      title: '客户分组'
    },
    component: () => import('../views/crm/custGroup/custGroup.vue')
  },
  {
    path: '/crm/organizatio/userManage',
    name: '/crm/organizatio/userManage',
    meta: {
      title: '用户管理'
    },
    component: () => import('../views/crm/organizatio/userManage.vue')
  },
  {
    path: '/crm/organizatio/deptManage',
    name: '/crm/organizatio/deptManage',
    meta: {
      title: '部门管理'
    },
    component: () => import('../views/crm/organizatio/deptManage.vue')
  },
]

export default new Router({
  base: "/",
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js